import { FunctionComponent } from 'react';
import styles from './ValidationMessage.module.scss';

type Props = {
	children: React.ReactNode;
};

const ValidationMessage: FunctionComponent<Props> = ({ children }) => {
	return <div className={styles.warning}>{children}</div>;
};

export default ValidationMessage;
